import { MasterdataService } from '../masterdata.provider';
import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';

export class Masterdata extends BaseEntity {
    id: number;
    name: string;
    type: string;
}

export class MasterdataRestService extends BaseService<Masterdata> {

    constructor(
        protected Restangular: Restangular.IService, 
        protected AppService: AppService
    ) {
        "ngInject";
        super(Restangular, AppService);
    }

    public setItemName = (name:string) => {
        this.itemName = name;
        this.collection = this.Restangular.all(this.itemName);
        return true;
    }

    public postItem = (type: string, data: Masterdata) => {
        return this.collection.customPOST(data, type).then((response) => {
            this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            return response;
        }).catch(error => {
            this.AppService.NotifyService.error('Foutmelding', error);
            return error;
        });
    }

    public getItems = (type: string) => {
        return this.collection.customGET('types/' + type).then((response) => {
            return response.plain();
        })
    }
}


// WEBPACK FOOTER //
// ./~/@abosol/masterdata/src/services/masterdata.service.ts